import { css } from "@emotion/react"

export const GlobalStyle = css`
  * {
    box-sizing: border-box;
    font-family: var(--brown) !important;
    :focus-visible {
      border: 2px dashed white;
      outline-offset: 2px;
      outline: 3px dashed #10059f;
    }
  }

  :root {
    direction: rtl;
    font-family: var(--brown) !important;
    direction: rtl;
  }

  body {
    font-family: var(--brown) !important;
  }

  html {
    overscroll-behavior-x: none;
  }

  .swiper {
    width: 100%;
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .swiper-slide {
    background-position: center;
    background-size: cover;
    width: calc(100% - 40px);
  }

  .swiper-button-disabled {
    opacity: 0.3;
  }

  strong {
    font-weight: 400;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0px 1000px white inset !important;
    box-shadow: 0 0 0px 1000px white inset !important;
  }

  .react-calendar__title--hover {
    background-color: red !important;
  }

  input::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
  }

  a: {
    color: #25272b;
  }
`
